import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { IoService } from '@core/services/io.service';
import { StoreService } from '@core/services/store.service';

@Injectable({ providedIn: 'root' })
export class StoreIdGuard {
  private readonly STORE_KEY = 'storeId';

  constructor(
    private router: Router,
    private storeSvc: StoreService, // ① inject the helper
    private ioService: IoService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    /* ----------------------------------------- *
     * 1️⃣  Find the store number (param beats LS)
     * ----------------------------------------- */
    const idFromQuery = route.queryParamMap.get('storeId');
    const idFromCache = localStorage.getItem(this.STORE_KEY);
    const storeId = idFromQuery ?? idFromCache;

    const firstNonEmpty = (...v: (string | null | undefined)[]) => v.find((x) => x && x.trim()) ?? 'DEFAULT';
    const correlationId = firstNonEmpty(
      route.queryParamMap.get('correlationId'),
      localStorage.getItem('correlationId'),
    );

    /* ----------------------------------------- *
     * 2️⃣  Redirect if missing
     * ----------------------------------------- */
    if (!storeId || !correlationId) {
      return this.router.parseUrl('/error-storeid-missing');
    }

    /* ----------------------------------------- *
     * 3️⃣  Persist + publish
     * ----------------------------------------- */

    localStorage.setItem(this.STORE_KEY, storeId);
    localStorage.setItem('correlationId', correlationId);
    this.storeSvc.setStoreId(storeId);

    /* ----------------------------------------- *
     * 4️⃣  Allow navigation
     * ----------------------------------------- */
    return true;
  }
}
